module.exports = __webpack_public_path__ + "static/img/p1-4.75c9108.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-4.png
// module id = 5FGd
// module chunks = 0